import { useDirection } from '@/app/providers';
import { Button } from '@shared/components/ui/button';

/**
 * Language switcher toggle button
 * Switches between Arabic and English
 * Shows flag of the language you'll switch TO
 */
export function LanguageSwitcher({ variant = 'ghost', size = 'sm' }) {
  const { locale, toggleLocale } = useDirection();

  // Show the flag of the language you'll switch to
  const flag = locale === 'ar' ? '🇺🇸' : '🇸🇦';
  const label = locale === 'ar' ? 'EN' : 'ع';

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleLocale}
      className="gap-1.5 font-medium"
      aria-label={locale === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
    >
      <span className="text-base">{flag}</span>
      <span>{label}</span>
    </Button>
  );
}
